import React from 'react'
import PropTypes from 'prop-types'
import { get, find } from 'lodash'

import Select from 'react-select'
import Creatable from 'react-select/lib/Creatable'
import { withStyles } from '@material-ui/core/styles'
import { DataTypeProvider } from '@devexpress/dx-react-grid'

const styles = {}

const Formatter = ({ column, row, value }) =>
  get(value, column.label, 'NOT FOUND')

const EditorBase = ({ column, row, value, onValueChange, classes }) => {
  const handleChange = targetValue => {
    if (!targetValue) {
      onValueChange()
      return
    }
    onValueChange({ [column.value]: targetValue.value })
  }

  const toOption = value =>
    value && {
      label: value[column.label],
      value: value[column.value]
    }
  const SelectField = !!column.createOption ? Creatable : Select
  return (
    <SelectField
      isClearable={!!column.createOption}
      isDisabled={column.loading}
      isLoading={column.loading}
      onChange={handleChange}
      onCreateOption={value =>
        !!column.createOption && column.createOption(value).then(onValueChange)
      }
      options={column.datasource && column.datasource.map(toOption)}
      value={
        value &&
        toOption(
          find(column.datasource, { [column.value]: value[column.value] })
        )
      }
    />
  )
}

EditorBase.propTypes = {
  value: PropTypes.any,
  onValueChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

EditorBase.defaultProps = {
  value: undefined
}

const Editor = withStyles(styles)(EditorBase)

const availableFilterOperations = ['contains', 'equal', 'notEqual']

const SelectTypeProvider = props => (
  <DataTypeProvider
    formatterComponent={Formatter}
    editorComponent={Editor}
    availableFilterOperations={availableFilterOperations}
    {...props}
  />
)

export default SelectTypeProvider
